import { pick, omit } from 'lodash-es'
import { findEpiSuiteGroupById } from '@/components/combined-predict/models/epiSuite/epiSuiteColumnGroups'
import { getTitle, makeModelTable, getSummaryValue } from '../utils'
import { getPredictionDataBySource } from '@/components/combined-predict/models/epiSuite/utils'

const summaryMapper = (item, meta) => {
  const summaryValues = meta?.children?.map((child) => {
    const value = getPredictionDataBySource(item, child.id)
    return getSummaryValue({ value, unit: child?.unit }, child?.name)
  })

  const summaryValuesToShow = omit(item, ['smiles', 'parameters', 'notes', 'output', 'property'])
  const summaryValuesTable = makeModelTable(summaryValuesToShow)

  return {
    values: summaryValues,
    tables: [summaryValuesTable],
  }
}

const descriptorsMapper = (item) => {
  const dermalAbsorbedDoseKeys = [
    'skinSurfaceAreaCm2',
    'exposureEventsPerDay',
    'exposureDurationYears',
    'exposureDaysPerYear',
    'bodyWeightKg',
    'averagingTimeDays',
  ]

  const parameters = omit(item?.parameters, 'smiles')

  const parametersToShow = omit(parameters, dermalAbsorbedDoseKeys)
  const dermalAbsorbedDoseParameters = pick(parameters, dermalAbsorbedDoseKeys)

  const parameterTable = makeModelTable(parametersToShow, 'Parameters')
  const dermalAbsorbedDoseTable = makeModelTable(dermalAbsorbedDoseParameters, 'Dermal Absorbed Dose')

  return {
    tables: [parameterTable, dermalAbsorbedDoseTable],
  }
}

const dermWin = (items) => {
  const item = items?.find((i) => i?.property === 'dermalPermeability')
  const meta = findEpiSuiteGroupById('dermalPermeability')

  return {
    title: getTitle(meta),
    description: 'Permeability Coefficient',
    helpPage: meta?.helpPage,
    summary: summaryMapper(item, meta),
    model: descriptorsMapper(item),
    modelOutput: item?.output ?? null,
  }
}

export { dermWin }
